<template>
    <div class="filters">
        <component 
            v-for="(f, i) in filters" 
            :key="f.key" 
            :is="f.co" 
            :isFirst="i === 0"
            :isSeventh="i === 7"
            :urlQuery="f.data"
            @add="addFilter" 
            @remove="removeFilter" 
            ref="filters"></component>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchFilter from '../components/SearchFilter'

export default {
    components: {
        SearchFilter
    },
    data: function () {
        return {
            numFilters: 1,
            filters: []
        }
    },
    props: {
        'urlFilters': Array
    },
    watch: {
        'urlFilters' (newVal, oldVal) {
            if (newVal != oldVal) {
                this.setUrlFilters()
                if (newVal.length == 0) {
                    this.clearFilters();
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            'type': 'search/type',
        }),
        fieldMap () {
           return this.$i18n.messages[this.$i18n.locale].search_fields_map;
        }
    },
    methods: {
        addFilter() {
            if (this.numFilters > 7) return;
            this.filters.push({key: this.numFilters, co: SearchFilter});
            this.numFilters++;
        },
        removeFilter(id) {
            this.filters = this.filters.filter(f => f.key != id) 
        },
        getTerms (searchType) {
            // returns array of terms for advanced search component
            let terms = [];
            for (const [i, filter] of this.$refs.filters.entries()) {
                if (filter.searchTerm.length) {
                    let term = [];  
                    let field = this.fieldMap[searchType][filter.selectedField];
                    term.push(field);
                    term.push('_contains')
                    term.push(filter.searchTerm)
                    if (filter.selectedBoolean && i != this.$refs.filters.length - 1) {
                        term.push(filter.selectedBoolean);
                    }
                    terms.push(term);
                }
            }

            if (terms.length) this.$store.dispatch('results/printable_query', terms);
            return terms;
        },
        clearFilters () {
            this.filters.forEach((filter, i) => {
                this.$set(this.filters, i, {
                    key: i,
                    co: SearchFilter,
                    data: {
                        selected: 'Keywords/Description',
                        searchTerm: '',
                        boolean: '_and'
                    }
                })
            })
        },
        setUrlFilters ()  {
            // console.log('setting filters')
            // sets filters and input values on mount
            this.urlFilters.forEach((filter,i, arr) => {
                let pieces = filter.split('::');
                let map = this.fieldMap[this.type];
                let selected = Object.keys(map).find(key => map[key] === pieces[0]);
                let boolean = i == arr.length - 1 ? "_and" : pieces[pieces.length-1];
                let term = pieces[2];
                let filterData = {
                    selected: selected,
                    searchTerm: term,
                    boolean: boolean
                }

                this.$set(this.filters, i, {
                    key: i,
                    co: SearchFilter,
                    data: filterData
                })
            })
        }
    },
    mounted () {
        if (this.urlFilters.length) {
            this.setUrlFilters();
        } else {
            this.filters.push({
                key: 0,
                co: SearchFilter
            })
        }

        this.$nextTick(() => {
            this.getTerms(this.type);
        });
    },
}
</script>

<style scoped lang="scss">
.filters {
    flex-grow: 1;
}

@media (max-width: $mq-max-width-desktop-sml) {
    .filters {
        width: 100%;
    }
}
</style>